import React, { memo } from 'react'

import ModelSettingsHeader from './Components/ModelSettingsHeader/ModelSettingsHeader'
import ViewerHeader from './Components/ViewerHeader/ViewerHeader'

function Header() {
  return (
    <div className="header">
      <ModelSettingsHeader />
      <ViewerHeader />
    </div>
  )
}

export default memo(Header)
